import React from 'react';
import { t } from 'react-switch-lang';

const returnTitle = (idCase) => {
  switch (idCase) {
   
    case 'user':
      return t('users.user');
   
      default:
      return '';
  }
};

export default returnTitle;
